export function findParentComponentByName(
  vm,
  componentName
) {
  let component;
  let parent = vm.$parent;
  while (parent && !component) {
    if (parent.$options.name === componentName) {
      component = parent
    }
    parent = parent.$parent
  }

  return component
}